import React from "react";
import { SvgIcon } from "./SvgIcon";
var smallPath = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  x: "0",
  y: "0",
  width: "20",
  height: "20",
  rx: "10"
}), /*#__PURE__*/React.createElement("rect", {
  className: "checkicon-fill",
  x: "0",
  y: "0",
  width: "20",
  height: "20",
  rx: "5"
}), /*#__PURE__*/React.createElement("path", {
  className: "checkicon-check",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M6.00134645 9.81868355 9.12119517 13.003429 14.9964286 7"
})));
var paths = {
  s: smallPath,
  m: smallPath,
  l: smallPath
};
export var CheckboxIcon = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    paths: paths
  }, props));
});